'use client'
import { Editor } from "@tinymce/tinymce-react";
import {Util} from "../../base/Util";
import { Row, Col, Alert } from "react-bootstrap";
import InputBase from "../component-base/input/InputBase";
import { createRef } from "react";
import { InputInterface } from "../component-base/input/interface/input";
import { State as BaseState} from "../component-base/input/interface/input";
import FormHandle from "../component-base/form/FormHandle";
import Warning from "../formGenComponents/Warning";

type File={
    publicUrl:string,
    filename:string
}
export interface State extends BaseState{
    alertVisible:boolean;
    alertmessage:string;
    alertVariant:string;
}
export default class ContentInput extends InputBase{
    public util=new Util();
    public apiKey=this.util.tinyKey;
    uploadedImages: string[] = [];
    deletedImages:string[]=[];
    public formRef:FormHandle|null=null;
    id:string|number=0;
    timer: NodeJS.Timeout|null;
    //state: State;
    constructor(props:InputInterface) {
            super(props);
            this.handleImageUpload = this.handleImageUpload.bind(this);
            this.warningComponent=createRef();
            this.state = {
                value:"",
                warning:"",
                alertVisible:false,
                alertmessage:'',
                alertVariant:'success'
            }as State;
            this.timer = null;
    }

    componentDidMount(): void {
        if(this.props.value){
            this.setState({...this.state,value:this.props.value});
            this.value=this.props.value;
        }
        this.formHandleValueSet();
        if(this.props.formRef){
            this.formRef=this.props.formRef.current;
        }
    }
    componentDidUpdate(prevProps: Readonly<InputInterface>, prevState: Readonly<State>, snapshot?: any): void {
        this.formHandleValueSetUpdate(prevProps);
        if(this.props.formRef){
            this.formRef=this.props.formRef.current;
        }
    }
    public getState():State{
        return this.state as State;
    }
    public formHandleValueSet():void{
        if(this.props.formRef&&this.props.name){
            let curr=this.props.formRef.current;
            if(curr!=null&&this.warningComponent.current!=null) curr.addInput(this.warningComponent);
            if(curr!=null&&curr.props.record!=null&&Object.keys(curr.props.record).length>0){
                let val=curr.props.record[this.props.name];
                let id=0;
                if(curr.props.idKey){
                    id=curr.props.record[curr.props.idKey];
                }
                this.value=val;
                this.id=id;
            }
            else if(curr!=null&&this.props.name)
            {
                let val=curr.props.recordLayout[this.props.name];
                this.id=0;
                this.value=val;
            }
        }
    }
    public formHandleValueSetUpdate(prevProps: Readonly<InputInterface>):void{
        if(prevProps.formRef&&this.props.formRef&&this.props.name){
            let prevCurr=prevProps.formRef.current||this.props.formRef.current;
            let curr=this.props.formRef.current;
            if(JSON.stringify(curr.props.record)!=='{}'&&curr.props.record!=null){
                let pastId=prevCurr.state.id;
                let currId=curr.props.record[prevCurr.props.idKey];
                if(pastId!==currId){
                    let val=curr.props.record[this.props.name];
                    this.value=val;
                    this.id=curr.state.id;
                }
            }else{
                let val=curr.props.recordLayout[this.props.name];
                this.value=val;
                this.id=0;
            }
        }
    }
    
    public handleImageUpload(blobInfo: any, _progress?: any) {
        return new Promise((resolve, reject) => {
            const util = new Util();
            const formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());

            util.fetchRequest('/upload/upload-image', 'post', formData)
                .then(res => res.json())
                .then((data: File) => {
                    this.uploadedImages.push(data.publicUrl);
                    this.setState(prev => ({ ...prev, alertVisible: true, alertmessage: blobInfo.filename() + ' uploaded!', alertVariant: 'success' } as State));
                    resolve(data.publicUrl);
                    if (this.timer) {
                        clearTimeout(this.timer);
                    }
                    this.timer =setTimeout(() => {
                        this.setState(prev => ({ ...prev, alertVisible: false, alertmessage: '', alertVariant: 'success' } as State));
                    }, 3000);
                })
                .catch(() => {
                    this.setState(prev => ({ ...prev, alertVisible: true, alertmessage: blobInfo.filename() + ' failed to upload!', alertVariant: 'danger' } as State));
                    reject('Upload failed');
                    if (this.timer) {
                        clearTimeout(this.timer);
                    }
                    this.timer =setTimeout(() => {
                        this.setState(prev => ({ ...prev, alertVisible: false, alertmessage: '', alertVariant: 'success' } as State));
                    }, 3000);
                });
        });
    }
    
    public async deleteApi(urls:string){
        const request=await this.util.fetchRequest('/upload/delete-image?'+urls,'delete');
        const data=await request.json();
        const status=await request.status;
        if(request.ok){

        }else
        {

        }
    }
    public async deleteImageHandle(src:string|string[]){
        if(typeof src=='string'){
            const index=this.uploadedImages.indexOf(src);
            this.uploadedImages=this.uploadedImages.splice(index,1);
            const del=await this.deleteApi('url='+src);

        }else
        {   if(src.length>0){
                const queryStr=encodeURI(src.join(','));
                const del=await this.deleteApi('url='+queryStr);
            }
        }
    }
    public handleEditorSetup=(editor:any)=>{
        editor.on('keydown', (e:any) => {
            const form=this.formRef;
        // Listen for Backspace (8) or Delete (46)
            if (e.keyCode === 8 || e.keyCode === 46) {
                const selectedNode = editor.selection.getNode();
                if (selectedNode && selectedNode.nodeName === 'IMG') {
                    const imageSrc = selectedNode.src;
                    if(String(form?.state.id)!=""&&Number(form?.state.id)!=0){
                        this.deletedImages.push(imageSrc);
                    }else this.deleteImageHandle(imageSrc);
                }
            }
        });
    }
    componentWillUnmount(): void {
         if (this.timer) {
            clearTimeout(this.timer); 
        }
        const form=this.formRef;
        // new record
        if((String(form?.state.id)==""||Number(form?.state.id)==0)&&form?.response==null){
            this.deleteImageHandle(this.uploadedImages);
        }
        // existing record
        if((String(form?.state.id)!=""||Number(form?.state.id)!=0)&&form?.response!=null){
            this.deleteImageHandle(this.deletedImages);
        } else if((String(form?.state.id)!=""||Number(form?.state.id)!=0)&&form?.response==null){
            this.deleteImageHandle(this.uploadedImages);
        }

        
    }
 
    render(){
        return(
            <Row>
            <Col>
            {this.getState().alertVisible?
            <Alert variant={this.getState().alertVariant}>
            {this.getState().alertmessage}   
            </Alert>
            :null}
            <Editor
            onEditorChange={(value:string)=>this.onChangeValue(value)}
            apiKey={this.apiKey}
            value={this.getStateValue()}
            init={{
                height:"800px",
                plugins: [
                // Core editing features
                'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount','image media link lists'
                ],
                images_upload_handler: (blobInfo: any, progress: any) => this.handleImageUpload(blobInfo, progress),
                automatic_uploads:true,
                pasta_data_images:true,
                toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography uploadcare | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                tinycomments_mode: 'embedded',
                tinycomments_author: 'Author name',
                mergetags_list: [
                { value: 'First.Name', title: 'First Name' },
                { value: 'Email', title: 'Email' },
                ],
                ai_request: (request:any, respondWith:any) => respondWith.string(() => Promise.reject('See docs to implement AI Assistant')),
                uploadcare_public_key: 'dfff09e4cb6c697f606a',
                setup:this.handleEditorSetup
            }}
            />
            <Warning name={this.name} warning={this.getWarning()}/>
            </Col>
            </Row>
        )
    }
}